import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Nav from "../components/Nav";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { verifyEmail } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Missing verification token.");
      return;
    }
    let cancelled = false;
    (async () => {
      const res = await verifyEmail(token);
      if (cancelled) return;
      if (!res.ok) {
        setError(res.error);
        return;
      }
      setDone(true);
      setTimeout(() => nav("/my-cards"), 800);
    })();
    return () => { cancelled = true; };
  }, [token, verifyEmail, nav]);

  return (
    <div>
      <Nav />
      <section className="border-b border-black bg-[color:var(--cc-bg-2)]">
        <div className="max-w-md mx-auto px-4 py-16 text-center">
          <h1 className="font-display font-black text-3xl tracking-tighter">
            {done ? "Email verified" : error ? "Verification failed" : "Verifying…"}
          </h1>
          {error && (
            <>
              <p className="mt-3 text-red-600">{error}</p>
              <Link to="/cardholder/login" className="mt-6 inline-block label-tag underline">Back to login</Link>
            </>
          )}
          {done && <p className="mt-3 text-neutral-700">Taking you to your cards…</p>}
        </div>
      </section>
    </div>
  );
}
